export const getLatestCourses = '/api/v1/courses?latest&limit=8';
export const getPopularCourses = '/api/v1/courses?popular&limit=8';

export const getCourseOverview = slug => {
    return `/api/v1/courses/${slug}/overview`;
};